module.exports = __webpack_public_path__ + "static/media/kw-selector.403d2f1b.svg";